export default "__VITE_ASSET__BG6bozB$__"